module.exports = __webpack_public_path__ + "static/media/RSU_Text_Bold.5d9b3a0d.ttf";